var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-rating-static c-rating--s@mobile u-flex u-flex-align-center",class:_vm.cssClass},[_c('div',{staticClass:"c-rating-static__stars",class:{
      'u-mr--xs': _vm.size != 'small',
      'u-mr--xxs': _vm.size == 'small'
    }},[_c('div',{staticClass:"c-rating-static__unselected"},[_c('div',{staticClass:"c-rating-static__selected",style:({
          width: _vm.width
        })})])]),(_vm.showRatingCount)?_c('span',{staticClass:"u-font-size-medium u-mr--xs"},[_vm._v(" ("+_vm._s(_vm.count)+") ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }